/** Format helpers for wallet pass previews (event-driven, not demo placeholders). */

export function venueShortLabel(venue, maxLen = 36) {
  const raw = String(venue || "").trim();
  if (!raw) return "";
  const first = raw.split("\n")[0].trim();
  if (first.length <= maxLen) return first;
  return `${first.slice(0, maxLen - 1)}…`;
}

export function formatPassDate(iso, timezone) {
  if (!iso) return "TBD";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
    return new Intl.DateTimeFormat(undefined, {
      timeZone: timezone || undefined,
      month: "short",
      day: "numeric",
    }).format(d);
  } catch {
    return String(iso).slice(0, 10);
  }
}

export function formatPassTime(iso, timezone) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return new Intl.DateTimeFormat(undefined, {
      timeZone: timezone || undefined,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
  } catch {
    return "—";
  }
}

export function defaultVenueLocation(event) {
  const label = venueShortLabel(event?.venue) || event?.title || "Event venue";
  return {
    enabled: true,
    latitude: null,
    longitude: null,
    label,
    relevantText: `You're near ${label} — have your pass ready at the gate.`,
    radiusMeters: 150,
  };
}

export function normalizeVenueLocation(raw, event) {
  const base = defaultVenueLocation(event);
  const src = raw && typeof raw === "object" ? raw : {};
  const lat = src.latitude === "" || src.latitude == null ? null : Number(src.latitude);
  const lng = src.longitude === "" || src.longitude == null ? null : Number(src.longitude);
  return {
    ...base,
    ...src,
    enabled: src.enabled !== false,
    latitude: Number.isFinite(lat) ? lat : null,
    longitude: Number.isFinite(lng) ? lng : null,
    radiusMeters: Number(src.radiusMeters) > 0 ? Number(src.radiusMeters) : 150,
  };
}

export function locationIsConfigured(loc) {
  return Boolean(loc?.enabled && Number.isFinite(loc.latitude) && Number.isFinite(loc.longitude));
}

export function haversineMeters(lat1, lon1, lat2, lon2) {
  const r = 6371000;
  const p1 = (lat1 * Math.PI) / 180;
  const p2 = (lat2 * Math.PI) / 180;
  const dphi = ((lat2 - lat1) * Math.PI) / 180;
  const dlmb = ((lon2 - lon1) * Math.PI) / 180;
  const a = Math.sin(dphi / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin(dlmb / 2) ** 2;
  return 2 * r * Math.asin(Math.min(1, Math.sqrt(a)));
}
